import { Progress } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";
import './StickyProgressBanner.css';

type Props = {
    progress: {
        processed: number;
        failed: number;
        total: number;
        progressPercent: number;
    };
};

export const StickyProgressBanner: React.FC<Props> = ({ progress }) => {
    const isComplete = progress.progressPercent === 100;

    return (
        <div className="sticky-banner">
            <div className="sticky-banner-content">
                <InfoCircleOutlined style={{ color: "#007A33", fontSize: 20 }} />
                <span className="sticky-banner-text">
                    Stato di avanzamento: {progress.processed}/{progress.total}
                </span>
            </div>
            <Progress
                percent={progress.progressPercent}
                status={isComplete ? "success" : "active"}
                strokeColor={isComplete ? "#52c41a" : "#007A33"}
                style={{ width: 180 }}
                showInfo
            />
        </div>
    );
};
